import axios from "axios";
import {
  TOPSPANDER_CABANG_GET_FAIL,
  TOPSPANDER_CABANG_GET_REQUEST,
  TOPSPANDER_CABANG_GET_RESET,
  TOPSPANDER_CABANG_GET_SUCCESS,
} from "../constants/TopSpanderCabangConstants";
import {
  API_TOPSPANDER_CABANG_GET,
  API_TOPSPANDER_CABANG_GET_DOWNLOAD,
} from "../init/api_url";
import { Logout } from "../../loginModul/actions/loginAction";
import { ActGeneralButtonDownloadSuccess } from "../../../general/components/button/ButtonDownloadsrc/action";

export const DownloadGetTopSpanderCabang =
  ({ dateStart, dateEnd, outlet, namaOutlet }) =>
  async (dispatch, getState) => {
    let fileName = "Top Spander " + namaOutlet + ".xlsx";
    const {
      userLogin: { token },
    } = getState();
    const data = await axios({
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: API_TOPSPANDER_CABANG_GET_DOWNLOAD,
      method: "GET",
      responseType: "blob", // important
      params: {
        startDate: dateStart,
        endDate: dateEnd,
        outlet: outlet,
      },
    });
    console.log("Download Data", data["Content-Disposition"], data);
    const url = window.URL.createObjectURL(new Blob([data.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    dispatch(ActGeneralButtonDownloadSuccess());
  };

export const GetTopSpanderCabang =
  ({ dateStart, dateEnd, outlet }) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: TOPSPANDER_CABANG_GET_REQUEST,
      });
      const {
        userLogin: { token },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          startDate: dateStart,
          endDate: dateEnd,
          outlet: outlet,
        },
      };
      const { data: data } = await axios.get(API_TOPSPANDER_CABANG_GET, config);
      console.log("testing Action get inventory  cabang", data);
      dispatch({
        type: TOPSPANDER_CABANG_GET_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response.status == 401) {
        dispatch(Logout());
      }
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      dispatch({
        type: TOPSPANDER_CABANG_GET_FAIL,
        payload: message,
      });
    }
  };

export const RGetTopSpanderCabang = () => async (dispatch, getState) => {
  dispatch({
    type: TOPSPANDER_CABANG_GET_RESET,
  });
};
